module.exports = __webpack_public_path__ + "assets/images/img/Image1.fefd0c93169c03fcfdcf47bb5958d6cd.jpg";